export default {
    carbonCredit: {
        view: 'Tazama',
        edit: 'Hariri',
        back: 'Rudi',
        preview: 'Hakiki',
        confirm: 'Thibitisha',
        cancel: 'Ghairi',
        dashboard: 'Dashibodi',
        select: 'Chagua',
        submit: 'Wasilisha',
        save: 'Hifadhi',
        title: 'Mikopo ya Kaboni',
        projects: 'Miradi',
        carbonProjectCredits: 'Mikopo ya Miradi ya Kaboni',
        carbonCreditProjects: 'Miradi ya Mikopo ya Kaboni',
        exportAs: 'Hamisha kama',
        downloadAsCSV: 'Pakua kama CSV',
        downloadAsExcel: 'Pakua kama Excel',
        downloadAsPDF: 'Pakua kama PDF',
        registerNewProject: 'Sajili Mradi Mpya',
        creditInfo: '*Hii ni idadi ya takriban ya mikopo. Idadi halisi ya mikopo inaweza kuwa tofauti baada ya uthibitisho.',
        search: 'Tafuta',
        projectTitle: 'Jina la Mradi',
        projectType: 'Aina ya Mradi',
        country: 'Nchi',
        totalCreditsGenerated: 'Jumla ya Mikopo Iliyozalishwa',
        status: 'Hali',
        descriptionPlaceholder: "Tafadhali toa maelezo ya mradi pamoja na malengo",
        filePreviewNotAvailable: 'Hakiki ya faili haipatikani kwa aina hii ya faili',
        active: 'Inayofanya kazi',
        inactive: 'Isiyofanya kazi',
        pending: 'Inasubiri',
        proposed: 'Iliyopendekezwa',
        planned: 'Iliyopangwa',
        inProgress: 'Inaendelea',
        operational: 'Inayofanya kazi',
        deactivated: 'Iliyokatwa',
        avoidedDeforestation: 'Ukataji wa Misitu Uliozuiliwa',
        agroForestry: 'Kilimo cha Misitu',
        regenerativeAgriculture: 'Kilimo cha Kurejesha',
        agroforestry: 'Kilimo cha Misitu',
        regenerative_agriculture: 'Kilimo cha Kurejesha',
        redd: 'REDD',
        arr: 'ARR',
        biochar: 'Biochar',
        erw: 'ERW',
        grassland: 'Malisho',
        projectDeletedSuccessfully: 'Mradi ulikatwa kwa mafanikio',
        projectUpdatedSuccessfully: 'Mradi ulisasishwa kwa mafanikio',
        projectRegisteredSuccessfully: 'Mradi ulisajiliwa kwa mafanikio',
        deactivateProjectError: 'Hitilafu katika kukata mradi',
        deactivate: 'Kata',
        deactivateProject: 'Kata Mradi',
        deactivateConfirmation: 'Una uhakika unataka kukata mradi huu?',
        delete: 'Futa',
        deleteProject: 'Futa Mradi',
        deleteConfirmation: 'Una uhakika unataka kufuta mradi huu? Kitendo hiki hakiwezi kutenduliwa.',
        projectRemovedSuccessfully: 'Mradi umefutwa kwa mafanikio',
        deleteProjectError: 'Hitilafu wakati wa kufuta mradi',
        changeStage: 'Badilisha Hatua',
        changeProjectStage: 'Badilisha Hatua ya Mradi',
        projectStageUpdatedSuccessfully: 'Hatua ya mradi imebadilishwa kwa mafanikio',
        updateStageError: 'Hitilafu wakati wa kubadilisha hatua ya mradi',
        stages: {
            planned: 'Iliyopangwa',
            operational: 'Inafanya Kazi',
            inValidation: 'Katika Uhakiki',
            inVerification: 'Katika Uthibitisho',
            creditsIssued: 'Mikopo Imetolewa',
        },
        registerProject: 'Sajili Mradi Mpya',
        editProject: 'Hariri Mradi',

        register: { 
            title: 'Sajili Mradi',
            editTitle: 'Hariri Mradi',
            projectTitle: 'Jina la Mradi',
            projectType: 'Aina ya Mradi',
            pinVerification: 'Uthibitishaji wa PIN',
            pinVerificationEnabled: 'Imewezeshwa',
            pinVerificationDisabled: 'Imezimwa',
            pinVerificationHint: 'Ikiwa imewezeshwa, wakulima lazima wathibitishe PIN ya tarakimu 6 iliyotumwa kwa barua pepe yao kabla ya kusaini mkataba mtandaoni.',
            description: 'Maelezo',
            selectCountry: "Chagua Nchi",
            selectOrganization: 'Chagua Mashirika',
            status: 'Hali',
            projectStage: 'Hatua ya Mradi',
            selectProjectStage: 'Chagua Hatua ya Mradi',
            creditType: 'Aina ya Mikopo',
            creditStart: 'Mwanzo wa Mikopo',
            creditEnd: 'Mwisho wa Mikopo',
            standardMethodology: 'Kiwango/Mbinu',
            validationDocumentation: 'Nyaraka za Uthibitisho',
            vintage: 'Mvinyo',
            currency: 'Sarafu',
            projectInfo: 'Maelezo ya Mradi',
            organizationDetails: 'Maelezo ya Mashirika',
            attachmentTitle: 'Kiambatisho',
            attachmentInfo: 'Unaweza kuongeza nyaraka zozote za ziada, picha, video na faili za sauti zinazohusiana na mradi',
            documentation: 'Nyaraka',
            contractReviewDocumentsTitle: 'Nyaraka za Ukaguzi wa Mkataba',
            contractReviewDocumentsInfo: 'Chagua kwa hiari kiambatisho chochote hapo juu ili pia kionyeshwe kwa mkulima wakati wa ukaguzi wa mkataba mtandaoni, pamoja na kichwa, maelezo na mpangilio wa uonyeshaji.',
            attachmentDocTitle: 'Kichwa',
            attachmentDocDescription: 'Maelezo',
            showToFarmerDuringContractReview: 'Onyesha kwa mkulima wakati wa ukaguzi wa mkataba',
            moveUp: 'Hamisha juu',
            moveDown: 'Hamisha chini',
            displayOrder: 'Mpangilio wa uonyeshaji',
            kml: {
                title: 'Eneo la Mradi (KML)',
                info: 'Pakia faili la KML linaloeleza mpaka wa mradi. Eneo litachorwa kwenye ramani hapa chini, na picha itahifadhiwa pamoja na mradi ili ionyeshwe hadharani.',
                uploadLabel: 'Faili la KML',
                browse: 'Vinjari faili la .kml',
                previewHint: 'Utakapowasilisha, picha ya ramani hii itahifadhiwa pamoja na mradi.',
                savedSnapshot: 'Picha iliyohifadhiwa ya eneo la mradi',
                remove: 'Ondoa KML',
                parseError: 'Imeshindikana kusoma faili hili la KML. Tafadhali hakikisha lina maeneo au kuratibu sahihi.',
                areaLabel: 'Eneo la mradi',
                areaUnitLabel: 'Kipimo',
                areaPlaceholder: 'Weka eneo',
                uploaded: 'Imepakiwa',
                fromKml: 'Kutoka KML',
            },
            sdgsTitle: 'Malengo ya Maendeleo Endelevu (SDGs)',
            sdgsInfo: 'Tafadhali chagua malengo tu yanayohusiana na mradi huu maalum. Mashirika yatakuwa na uwezo wa kuona malengo tu yanayounganishwa na mradi huu.',
            dataCollectionTitle: 'Mzunguko wa Ukusanyaji wa Data',
            dataCollectionInfo: 'Ili kushiriki katika Programu ya Mikopo ya Kaboni, wakulima wanapaswa kutoa data ya kihistoria ya shamba wakati wa kujisajili na kuendelea kuwasilisha sasisho za data za mara kwa mara mradi programu inabaki kuwa hai. Hii inahakikisha ufuatiliaji sahihi wa utendaji wa kaboni kwa muda.',
            vintageYear: 'Mwaka wa Mvinyo',
            estimatedCredit: 'Mikopo ya Makadirio',
            pricePerCredit: 'Bei Kwa Mikopo',
            moduleName: 'Jina la Moduli',
            futureData: 'Ukusanyaji wa Data wa Baadaye wa Mara kwa Mara',
            score: 'Alama',
            approval: 'Idhini',

            projectAgreement: 'Makubaliano ya Mradi',
            headerImage: 'Picha ya Kichwa',
            headerImageInfo: '(Ukubwa wa picha ya kichwa 1920 x 420 pixel. Picha ya chaguo-msingi itabadilishwa na picha mpya unayopakia)',
            headerImagePlaceholder: "Picha ya Kichwa ya Chaguo-msingi",
            responsibleDimitraOffice: 'Ofisi ya Dimitra Inayohusika',
            selectDimitraOffice: 'Chagua Ofisi ya Dimitra',
            makeASelection: 'Fanya Uchaguzi',
            addNewDimitraOffice: 'Ongeza Ofisi Mpya ya Dimitra',
            editDimitraOffice: 'Hariri Ofisi ya Dimitra',
            officeName: 'Jina la Ofisi',
            contactPerson: 'Jina la Mtu wa Mawasiliano',
            phoneNumber: 'Nambari ya Simu',
            email: 'Barua pepe',
            address: 'Anwani',
            officeNameRequired: 'Jina la ofisi linahitajika',
            contactPersonRequired: 'Jina la mtu wa mawasiliano linahitajika',
            addressRequired: 'Anwani inahitajika',
            phoneNumberRequired: 'Nambari ya simu inahitajika',
            phoneNumberInvalid: 'Nambari ya simu si sahihi',
            phoneNumberLength: 'Nambari ya simu lazima iwe na tarakimu angalau 10',
            selectVintage: 'Chagua Mvinyo',
            officeAddedSuccessfully: 'Ofisi ya Dimitra iliongezwa kwa mafanikio',
            errorAddingOffice: 'Hitilafu katika kuongeza ofisi ya Dimitra',
            searchOrganizations: 'Tafuta Mashirika',
            searchOrganizationsPlaceholder: 'Tafuta kwa jina la shirika...',
            noOrganizationsFound: 'Hakuna mashirika yaliyopatikana',
            loadingOrganizations: 'Inapakia mashirika...',
            selectedOrganizations: 'Mashirika Yaliyochaguliwa',
            errorNegative: 'haiwezi kuwa hasi.',
            errorRequiredField: '{field} inahitajika.',
            errorOrganizationRequired: 'Shirika angalau moja lazima lichaguliwe.',
            errorVintageRequired: 'Ingizo angalau moja la mvinyo linahitajika.',
            errorVintageFieldsRequired: 'Sehemu zote za mvinyo (mwaka, mikopo, bei) zinahitajika.',
            allOrganizations: 'Mashirika Yote',
            removal: 'Kuondolewa',
            avoided: 'Iliyozuiliwa',
            mandatory: 'Lazima',
            scoreValidationError: 'Alama si sahihi kwa moduli "{module}". Alama lazima iwe nambari kamili 0 au zaidi.',
            approvalValidationError: 'Idhini si sahihi kwa moduli "{module}". Idhini lazima iwe nambari kamili kati ya 0 na 100.',
            saveError: 'Kuhifadhi mradi kushindwa',
            fileUploadFailed: 'Kupakia Faili Kushindwa',
            unsupportedFileFormat: 'Muundo wa faili usioendeshwa',
            errorUploadingFile: 'Hitilafu katika kupakia faili',
            scoreError: {
                invalid: 'Alama lazima iwe nambari sahihi',
                range: 'Alama lazima iwe 0 au zaidi',
                wholeNumber: 'Alama lazima iwe nambari kamili'
            },
            approvalError: {
                invalid: 'Idhini lazima iwe nambari sahihi',
                range: 'Idhini lazima iwe kati ya 0 na 100',
                wholeNumber: 'Idhini lazima iwe nambari kamili'
            },
            selectStatus: 'Chagua Hali',
            selectCreditType: 'Chagua Aina ya Mikopo',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Kiwango',
            browse: 'Tafuta',
            currencyPlaceholder: 'USD',
            selectFile: 'Chagua Faili',
            dragDropFiles: 'Buruta na uangushe faili hapa',
            hideDetails: 'Ficha Maelezo',
            viewDetails: 'Tazama Maelezo',
            website: 'Tovuti',
            month: 'Mwezi(zi)',
            year: 'Mwaka',
        },

        error: 'Hitilafu',
        success: 'Mafanikio',
        remove: 'Ondoa',

        plotTreeMapping: {
            title: 'Uchoraji wa Miti kwa Kiwanja',
            techniciansPlots: 'Viwanja vya Mafundi',
            techniciansPlotsTitle: 'Viwanja vya Mafundi',
            plotNumber: 'Nambari ya Kiwanja',
            addedBy: 'Imeongezwa Na',
            filterByDate: 'Chuja kwa Tarehe',
            selectDate: 'Chagua Tarehe',
            userRole: 'Jukumu la Mtumiaji',
            createdOn: 'Imeundwa',
            removeTechnicianPlotMessage: 'Una uhakika unataka kuondoa kiwanja {plotNo}?',
            noTechnicianPlots: 'Hakuna viwanja vya mafundi vilivyopatikana',
            noTechnicianPlotsHint: 'Viwanja vinaonekana hapa vinapounganishwa na ombi la uchoraji linalokabidhiwa mtaalamu.',
            clearFilters: 'Futa vichujio',
            project: 'Mradi',
            selectProject: 'Chagua Mradi',
            projectRequired: 'Mradi unahitajika',
            errorLoadingProjects: 'Imeshindwa kupakia miradi',
            farm: 'Shamba',
            errorLoadingFarmers: 'Imeshindwa kupakia wakulima wa mradi huu',
            errorLoadingFarms: 'Imeshindwa kupakia mashamba ya mradi huu',
            errorLoadingProjectBoundary: 'Imeshindwa kupakia mpaka wa eneo la mradi kutoka faili ya KML/KMZ iliyohifadhiwa.',
            projectBoundaryHint: 'Mpaka wa kijani unaonyesha eneo la mradi lililoidhinishwa kutoka faili ya KML/KMZ iliyosajiliwa.',
            plotOutsideProjectArea: 'Kiwanja Nje ya Eneo la Mradi',
            plotOutsideProjectAreaMessage: 'Mahali ulipochagua iko nje ya mpaka ulioidhinishwa wa {project}. Sogeza alama yako ndani ya eneo lililowekwa.',
            errorPlotOutsideRegisteredFarm: 'Mahali hapa pa shamba iko nje ya mashamba yote yaliyosajiliwa ya mradi. Chagua mahali ndani ya shamba lililosajiliwa.',
            errorCheckingFarmLocation: 'Imeshindwa kuthibitisha mahali pa shamba. Tafadhali jaribu tena.',
            close: 'Funga',
            plotLegendTitle: 'Legenda ya viwanja',
            plotMarkerLegendInfo: 'Viwanja vilivyopimwa hutumia alama ya bluu, vilivyopendekezwa njano, na vilivyokaguliwa kijani. Aikoni zinalingana na alama zilizochaguliwa kwenye ramani.',
            measuredPlot: 'Kiwanja kilichopimwa',
            suggestedPlot: 'Kiwanja kilichopendekezwa',
            auditedPlot: 'Kiwanja kilichokaguliwa',
            imports: {
                importData: 'Import Data',
                dialogTitle: 'Import audited plots from sheet',
                downloadTemplate: 'Download CSV template',
                templateNote: 'Use columns ID, Original located, Real location, and Comments (header names are matched case-insensitive). ID is the numeric suffix of the tree-mapping request id (e.g. 56 for RE-ESTA056). Real location must be DMS pairs such as 21°41\'34.68"N, 104°31\'28.72"W. Rows with an empty Real location are skipped and not sent to the server.',
                selectFile: 'Select file',
                dropHere: 'or drop CSV / Excel here',
                invalidFileFormat: 'Please upload a .csv, .xls, or .xlsx file.',
                invalidHeaders: 'Invalid column headers',
                headerMismatch: 'The header row must include ID and Real location (see template). Expected columns: {expected}.',
                fileSelected: 'File selected',
                importing: 'Importing…',
                success: 'Import completed',
                partialSuccess: 'Import finished with some row errors',
                serverError: 'Import failed',
                rowErrorsSummary: '{count} row(s) had errors. Check the API response details or fix the sheet and try again.',
                rowInvalidId: 'Invalid or missing ID on spreadsheet rows: {rows}. ID must be the numeric suffix of the request (e.g. 56).',
                noImportableRows: 'No rows to import. Add a value in Real location for rows you want imported; empty Real location rows are skipped.',
                emptyDataRows: 'No valid data rows found in the file.',
                cancel: 'Cancel',
                import: 'Import',
                removeFile: 'Remove file',
                resultDialogTitle: 'Import plots',
                importCompletedLabel: 'Import completed',
                recordsImportedLine: '{success} of {total} records imported',
                totalRecordsLabel: 'Total records',
                failedLabel: 'Failed',
                successLabel: 'Success',
                skippedLabel: 'Skipped',
                colSpreadsheetId: 'ID',
                colRequestId: 'Request ID',
                colPlotNo: 'Plot no.',
                colLocation: 'Location / detail',
                colStatus: 'Status',
                colAction: 'Action',
                statusSuccess: 'Success',
                statusFailed: 'Failed',
                statusSkipped: 'Skipped',
                retryImportTooltip: 'Import again',
                removeFromListTooltip: 'Remove from list',
                viewRequestTooltip: 'View request',
            },
        },

        projectInfo: {
            title: 'Maelezo ya Mradi',
            organizationDetail: 'Maelezo ya Shirika',
            subOrganizations: 'Mashirika ya Chini',
            search: 'Tafuta',
            organizations: 'Mashirika',
            users: 'Watumiaji',
            registrationDate: 'Tarehe ya Usajili',
            close: 'Funga',
            country: 'Nchi',
            organizationsAddress: 'Anwani ya Mashirika',
            blockchainAddress: 'Anwani ya Blockchain',
            creditType: 'Aina ya Mikopo',
            projectType: 'Aina ya Mradi',
            officeName: 'Jina la Ofisi',
            contactPersonName: 'Jina la Mtu wa Mawasiliano',
            contactNumber: 'Nambari ya Mawasiliano',
            email: 'Barua pepe',
            address: 'Anwani',
            website: 'Tovuti',
            companyName: 'Jina la Kampuni',
            companyAddress: 'Anwani ya Kampuni',
            web: 'Tovuti',
            vintageYear: 'Mwaka wa Mvinyo',
            estimatedCredits: 'Mikopo ya Makadirio',
            pricePerCredit: 'Bei Kwa Mikopo',
            module: 'Moduli',
            recurring: 'Ya mara kwa mara',
            score: 'Alama',
            approval: 'Idhini',
            responsibleDimitraOffice: 'Ofisi ya Dimitra Inayohusika',
            status: 'Hali',
            standardMethodology: 'Kiwango/Mbinu',
            validationDocumentation: 'Nyaraka za Uthibitisho',
            creditStart: 'Mwanzo wa Mikopo',
            creditEnd: 'Mwisho wa Mikopo',
            attachmentTitle: 'Kiambatisho',
            sdgsTitle: 'Malengo ya Maendeleo Endelevu (SDGs)',
            dataCollectionTitle: 'Mzunguko wa Ukusanyaji wa Data',
            dataCollectionInfo: 'Ili kushiriki katika Programu ya Mikopo ya Kaboni, wakulima wanapaswa kutoa data ya kihistoria ya shamba wakati wa kujisajili na kuendelea kuwasilisha sasisho za data za mara kwa mara mradi programu inabaki kuwa hai. Hii inahakikisha ufuatiliaji sahihi wa utendaji wa kaboni kwa muda.',
            vintage: 'Mvinyo',
            moduleName: 'Jina la Moduli',
            futureData: 'Ukusanyaji wa Data wa Baadaye wa Mara kwa Mara',
            estimatedCredit: 'Mikopo ya Makadirio',
        },

        user: {
            title: 'Mtumiaji(wa) wa Mikopo ya Kaboni',
            selectOrganization: 'Chagua Shirika',
            selectProject: 'Chagua Mradi',
            allUsers: 'Watumiaji Wote',
            activeUsers: 'Watumiaji Wanaofanya Kazi',
            deactivatedUsers: 'Watumiaji Waliokatwa',
            pendingUsers: 'Watumiaji Wanasubiri',
            search: 'Tafuta',
            farmerName: 'Jina la Mkulima',
            farmName: 'Jina la Shamba',
            organizations: 'Mashirika',
            country: 'Nchi',
            projectTitle: 'Jina la Mradi',
            registerProject: 'Sajili Mradi Mpya',
            actions: 'Vitendo',
            noData: 'Hakuna watumiaji walipatikana.',
            view: 'Tazama',
            viewLandPermit: 'Tazama Hati ya Ardhi / Ruhusa',
            edit: 'Hariri',
            deactivate: 'Kata',
            deactivateUser: 'Kata Mtumiaji',
            deactivateConfirmation: 'Una uhakika unataka kukata mtumiaji huyu?',
            activate: 'Kufanya Kazi',
            activateUser: 'Kufanya Kazi Mtumiaji',
            activateConfirmation: 'Una uhakika unataka kufanya kazi mtumiaji huyu?',
            deactivatedSuccessfully: 'Mtumiaji ulikatwa kwa mafanikio',
            activatedSuccessfully: 'Mtumiaji ulifanya kazi kwa mafanikio',
            deactivationFailed: 'Hitilafu katika kukata mtumiaji',
            activationFailed: 'Hitilafu katika kuamsha mtumiaji',
            delete: 'Ondoa kwenye mradi',
            deleteUser: 'Ondoa mtumiaji kwenye mikopo ya kaboni',
            deleteConfirmation: 'Hii itaondoa viungo vyote vya mradi wa mikopo ya kaboni kwa mashamba ya mtumiaji huyu. Akaunti ya mtumiaji haitafutwa. Endelea?',
            deletedSuccessfully: 'Mtumiaji ameondolewa kwenye mikopo ya kaboni kwa mafanikio',
            deleteFailed: 'Imeshindwa kuondoa mtumiaji kwenye mikopo ya kaboni',
            exportAsPdf: 'Hamisha kama PDF',
            projectDetails: 'Maelezo ya Mradi',
            dateJoined: 'Tarehe ya Kujiunga',
            cropGrowingPractice: 'Mazoea ya Kukuza Mazao',
            farm: 'Shamba',
            rejectAll: 'KATA YOTE',
            acceptAll: 'KUBALI YOTE',
            confirmRejectAll: 'Uko karibu kukata maombi ya mashamba yote kujiunga na mradi wa mikopo ya kaboni. Kitendo hiki kitakata kila shamba lililowasilishwa na mkulima katika ombi hili. Una uhakika unataka kuendelea?',
            confirmAcceptAll: 'Uko karibu kukubali maombi ya mashamba yote kujiunga na mradi wa mikopo ya kaboni. Kitendo hiki kitajumuisha kila shamba lililowasilishwa na mkulima katika ombi hili. Una uhakika unataka kuendelea?',
            dateOfRegistration: 'Tarehe ya Usajili',
            farmRegistrationId: 'Kitambulisho cha Usajili wa Shamba',
            dimitraFarmId: 'Kitambulisho cha Shamba la Dimitra',
            notTheFarmer: "Mimi si Mkulima",
            farmerFirstName: 'Jina la Kwanza la Mkulima',
            farmerMiddleName: 'Jina la Kati la Mkulima',
            farmerLastName: 'Jina la Mwisho la Mkulima',
            farmerRegistrationId: 'Kitambulisho cha Usajili wa Mkulima',
            dimitraFarmerId: 'Kitambulisho cha Mkulima wa Dimitra',
            farmGeofence: 'Geofence ya Shamba',
            viewGeofence: 'Tazama Geofence',
            totalFarmSize: 'Ukubwa wa Jumla wa Shamba',
            mainGoals: 'Malengo Yako Makuu ni Nini',
            ownershipType: 'Aina ya Umiliki',
            certifications: 'Udhibitisho',
            productionType: 'Aina ya Uzalishaji',
            landTitle: 'Hati ya Ardhi',
            farmLocationAddress: 'Anwani ya Mahali pa Shamba',
            farmCoordinate: 'Kuratibu ya Shamba',
            farmerAgreement: 'Makubaliano ya Mkulima',
            viewSignedAgreement: 'Tazama makubaliano yaliyotiwa sahihi yaliyowasilishwa na ombi.',
            viewAgreement: 'TAZAMA MAKUBALIANO',
            acceptanceStatus: 'Hali ya Kukubaliwa',
            currentStatus: 'Hali ya Sasa',
            reject: 'KATA',
            accept: 'KUBALI',
            farmActivitySubmissions: 'Wasilisho za Shughuli za Shamba',
            farmActivitySubmissionsDesc: 'Rekodi zilizowasilishwa za mazoea ya kilimo na sasisho zinazohitajika kwa uthibitisho wa mikopo ya kaboni.',
            viewFarmData: 'TAZAMA DATA YA SHAMBA',
            farmData: 'Data ya Shamba',
            farmDataDesc: 'Unda ripoti zako kwa kuunganisha data ya uzalishaji kutoka vyanzo mbalimbali. Chagua chanzo kimoja au zaidi ili kutunga orodha kamili ya mahali pa uzalishaji kwa ripoti zako.',
            crops: 'Mazao',
            sowing: 'Kupanda',
            seedling: 'Mche',
            fertilizer: 'Mbolea',
            fertilizerError: 'Wasilisho lisilo kamili: Maelezo ya mbolea kwa miezi 4 yanakosekana kutoka kwa ingizo la mkulima.',
            harvesting: 'Kuvuna',
            livestock: 'Mifugo',
            equipment: 'Vifaa',
            projectRequests: 'Maombi ya Miradi',
            userNameAndId: 'Jina la Mtumiaji na ID',
            email: 'Barua pepe',
            userRole: 'Mtumiaji',
            status: 'Hali',
            userRegistrationDate: 'Tarehe ya Usajili wa Mtumiaji',
            pending: 'Inasubiri',
            deactivated: 'Iliyokatwa',
            active: 'Inayofanya kazi',
            statusInProgress: 'Inaendelea',
            statusInReview: 'Inakaguliwa',
            statusApprovedWithWarning: 'Imeidhinishwa (Na Onyo)',
            statusApproved: 'Imeidhinishwa',
            statusRequireUpdate: 'Inahitaji Usasishaji',
            statusRejected: 'Imekataliwa',
            selectProjectTypeFirst: 'Chagua Aina ya Miradi Kwanza',
            noFarmsToReject: 'Hakuna mashamba ya kukataa',
            allFarmsRejected: 'Mashamba yote yamekataliwa kwa mafanikio',
            rejectAllError: 'Kukata mashamba yote kumeshindwa',
            noFarmsToAccept: 'Hakuna mashamba ya kukubali',
            allFarmsAccepted: 'Mashamba yote yamekubaliwa kwa mafanikio',
            acceptAllError: 'Kukubali mashamba yote kumeshindwa',
            farmNotFound: 'Shamba halijapatikana au halijaunganishwa na mradi',
            farmAlreadyRejected: 'Shamba tayari limekataliwa',
            farmRejected: 'Shamba limekataliwa kwa mafanikio',
            rejectFarmError: 'Kukata shamba kumeshindwa',
            farmAlreadyAccepted: 'Shamba tayari limekubaliwa',
            farmAccepted: 'Shamba limekubaliwa kwa mafanikio',
            acceptFarmError: 'Kukubali shamba kumeshindwa',
        },

        manageTrees: {
            pageTitle: 'Simamia Miti',
            addNewTree: 'Ongeza Mti Mpya',
            updateTreeInfo: 'Sasisha Taarifa za Mti',
            treeList: 'Orodha ya Miti',
            importInBulk: 'Ingiza kwa Wingi',
            downloadTrees: 'Pakua Miti',
            save: 'Hifadhi',
            cancel: 'Ghairi',
            treeId: 'Kitambulisho cha Mti',
            project: 'Mradi',
            search: 'Tafuta',
            treeIdHeader: 'Kitambulisho cha Mti',
            treeTypeAndSpecies: 'Aina na Spishi ya Mti',
            geoCoordinates: 'Kuratibu za Kijiografia',
            addedBy: 'Imeongezwa Na',
            datePlanted: 'Tarehe ya Kupanda',
            view: 'Tazama',
            edit: 'Hariri',
            delete: 'Futa',
            currentPage: 'Ukurasa wa Sasa',
            allPages: 'Kurasa Zote',
            none: 'Hakuna',
            selected: 'Imechaguliwa',
            deleteTree: 'Futa Mti',
            deleteTreeConfirm: 'Una uhakika unataka kufuta mti huu? Kitendo hiki hakiwezi kutenduliwa.',
            importTreesInBulk: 'Ingiza Miti kwa Wingi',
            uploadCsvOrExcel: 'Pakia faili la CSV au Excel',
            import: 'Ingiza',
            treeDeletedSuccessfully: 'Mti umefutwa kwa mafanikio.',
            treeDeleteFailed: 'Imeshindwa kufuta mti.',
            downloadingTrees: 'Inapakua miti iliyochaguliwa...',
            importStarted: 'Uingizaji umeanza.',
            selectAllPagesNotSupported: 'Kuchagua kurasa zote bado hakuungwa mkono.',
            idLabel: 'Kitambulisho (Mfano, Id ya mti)',
            additionalId: 'Kitambulisho cha Ziada',
            selectFarm: 'Chagua Shamba',
            selectZone: 'Chagua Eneo',
            gpsCoordinates: 'Kuratibu za GPS',
            gpsHint: 'mfano. 26.4443186, 87.2869355',
            locationInformation: 'Taarifa za Mahali',
            altitude: 'Mwinuko',
            seedlingName: 'Jina la mche',
            selectTreeType: 'Chagua Aina ya Mti',
            selectTreeSpecies: 'Chagua Spishi ya Mti',
            selectHealthCondition: 'Chagua Hali ya Afya',
            includeIn: 'Ungependa Kujumuisha Mti Huu Wapi?',
            additionalNotes: 'Maelezo ya Ziada',
            attachImages: 'Ambatisha Picha',
            selectFilesToUpload: 'Chagua Faili(s) za Kupakia',
            dragAndDrop: 'au buruta na uacha hapa',
            enterHere: 'Ingiza hapa',
            makeASelection: 'Fanya uchaguzi',
            avocado: 'Avokado',
            coffee: 'Kahawa',
            cacao: 'Kakao',
            fruitTree: 'Mti wa Matunda',
            timber: 'Mbao',
            other: 'Nyingine',
            guatemalan: 'Guatemalan',
            hass: 'Hass',
            reed: 'Reed',
            fuerte: 'Fuerte',
            healthy: 'Nzuri',
            moderate: 'Wastani',
            poor: 'Mbaya',
            dead: 'Imekufa',
            urban: 'Mjini',
            rural: 'Vijijini',
            forest: 'Msitu',
            farmland: 'Ardhi ya Kilimo',
            hillside: 'Upande wa Mlima',
            carbonCreditProject: 'Mradi wa Mikopo ya Kaboni',
            plotTreeMappingOption: 'Ramani ya Miti katika Shamba',
            both: 'Vyote',
            fieldRequired: 'Sehemu hii inahitajika.',
            treeCreatedSuccessfully: 'Mti umeundwa kwa mafanikio.',
            treeCreateFailed: 'Imeshindwa kuunda mti.',
            treeUpdatedSuccessfully: 'Mti umesasishwa kwa mafanikio.',
            treeUpdateFailed: 'Imeshindwa kusasisha mti.',
            treeLoadFailed: 'Imeshindwa kupakia data ya mti.',
            clusterDetails: 'Maelezo ya Kundi',
            trees: 'Miti',
            primaryTreeType: 'Aina Kuu ya Mti',
            treeType: 'Aina ya mti',
            bulkTreeDataImport: 'Uingizaji wa data za miti kwa wingi',
            downloadTemplateToBulkImportMessage: 'Pakua na tumia violezo vilivyo hapa chini kuingiza miti kwa wingi.',
            selectTemplate: 'Chagua kiolezo',
            bulkImportedSuccessMessage: 'Miti {count} imeingizwa kwa mafanikio.',
            back: 'Rudi',
            treeDetails: 'Maelezo ya Mti',
            treeHistory: 'Historia ya Mti',
            viewHistory: 'Tazama Historia',
            provideUpdates: 'Toa Masasisho',
            programType: 'Aina ya Programu',
            treeImages: 'Picha za Mti',
            treeImage: 'Picha ya Mti',
            treeQrCode: 'Msimbo wa QR wa Mti',
            treeAddedBy: 'Mti Umeongezwa na',
            username: 'Jina la Mtumiaji',
            downloadImage: 'Pakua Picha',
            dimitraAssetId: 'Kitambulisho cha Mali ya Dimitra',
            zone: 'Eneo',
            treeSpecies: 'Spishi ya Mti',
            dateOfPlantation: 'Tarehe ya Kupanda',
            ageOfTree: 'Umri wa Mti',
            healthCondition: 'Hali ya Afya',
            updatedBy: 'Imesasishwa na',
            updatedAt: 'Imesasishwa Saa',
            startDate: 'Tarehe ya Mwanzo',
            endDate: 'Tarehe ya Mwisho',
            whereWouldYouLikeToIncludeThisTree: 'Ungependa kujumuisha mti huu wapi?',
            selectModule: 'Chagua moduli',
            selectProject: 'Chagua mradi',
            selectNftProject: 'Chagua mradi wa NFT',
            loadingMore: 'Inapakia zaidi...',
            fetchNftListFailed: 'Imeshindwa kupata orodha ya NFT kwa sasa.',
            projectName: 'Jina la Mradi',
        },
    }
}